import _map from "lodash/map";
import React from 'react';
import classNames from 'classnames';
import styles from './Table.module.less';
export var CELL_ELEMENTS = {
  TD: 'td',
  TH: 'th'
};
export var TableCell = function TableCell(_ref) {
  var children = _ref.children,
      className = _ref.className,
      colSpan = _ref.colSpan,
      element = _ref.element,
      scope = _ref.scope,
      width = _ref.width;
  var Component = element;
  var derivedStyles = {
    width: width
  }; // Only `<th />` elements should be allowed scope
  // https://dequeuniversity.com/rules/axe/3.5/scope-attr-valid?application=axeAPI

  var canApplyScope = CELL_ELEMENTS.TH === element;
  return /*#__PURE__*/React.createElement(Component, {
    className: classNames(styles[element], className),
    style: derivedStyles,
    scope: canApplyScope ? scope : null,
    colSpan: colSpan
  }, children);
};

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line global-require
  var PropTypes = require('prop-types');

  TableCell.propTypes = {
    /** Type of cell to render. */
    element: PropTypes.oneOf(_map(CELL_ELEMENTS, function (component) {
      return component;
    })),

    /** Width of cell. */
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

    /** Scope to apply to the cell. */
    scope: PropTypes.oneOf(['col', 'row']),

    /** Class to apply to the table element. */
    className: PropTypes.string,

    /** Children to render within the cell. */
    children: PropTypes.node,
    colSpan: PropTypes.number
  };
}

TableCell.defaultProps = {
  children: null,
  className: null,
  element: CELL_ELEMENTS.TD,
  scope: null,
  width: null,
  colSpan: null
};